import React from "react";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const MAX_VISIBLE = 5;

  const getPages = () => {
    let start = Math.max(1, currentPage - Math.floor(MAX_VISIBLE / 2));
    let end = start + MAX_VISIBLE - 1;

    if (end > totalPages) {
      end = totalPages;
      start = Math.max(1, end - MAX_VISIBLE + 1);
    }

    const pages = [];
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };

  const pages = getPages();

  const handleClick = (page, disabled = false) => {
    if (disabled) return;
    onPageChange(page);
  };

  return (
    <div className="custom-pagination">
      {/* PREV */}
      <span
        className={`page-btn ${currentPage === 1 ? "disabled" : ""}`}
        onClick={() =>
          handleClick(currentPage - 1, currentPage === 1)
        }
      >
        ‹
      </span>

      {/* FIRST PAGE */}
      {pages[0] > 1 && (
        <>
          <span
            className="page-btn"
            onClick={() => handleClick(1)}
          >
            1
          </span>
          {pages[0] > 2 && <span className="dots">…</span>}
        </>
      )}

      {/* MIDDLE PAGES */}
      {pages.map((page) => (
        <span
          key={page}
          className={`page-btn ${
            page === currentPage ? "active" : ""
          }`}
          onClick={() => handleClick(page)}
        >
          {page}
        </span>
      ))}

      {/* LAST PAGE */}
      {pages[pages.length - 1] < totalPages && (
        <>
          {pages[pages.length - 1] < totalPages - 1 && (
            <span className="dots">…</span>
          )}
          <span
            className="page-btn"
            onClick={() => handleClick(totalPages)}
          >
            {totalPages}
          </span>
        </>
      )}

      {/* NEXT */}
      <span
        className={`page-btn ${
          currentPage === totalPages ? "disabled" : ""
        }`}
        onClick={() =>
          handleClick(
            currentPage + 1,
            currentPage === totalPages
          )
        }
      >
        ›
      </span>
    </div>
  );
};

export default Pagination;
